import React, { useState } from "react";
import { Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { api, extractErrorMessage } from "../../../../util/api";
import { camelizeKeys, snakifyKeys } from "../../../../util/helpers";
import { CaseTipForm } from "./CaseTipForm";

export const EditCaseTipModal = ({ caseTip, onUpdate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleUpdate = async (params) => {
    setError(null);
    try {
      const res = await api.patch(`/admin/case_tips/${params.id}`, snakifyKeys(params));

      if (onUpdate) {
        onUpdate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Case Tip</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleUpdate} initialValues={camelizeKeys({ ...caseTip })}>
            {(props) => <CaseTipForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
